import React, { useContext, useState } from 'react';
import Loader from '@/components/Layout/Loader';
import ProEmailsNewList from '@/components/Email/ProEmail/ProEmailsNewList';
import ProEmailNewTitle from '@/components/Email/ProEmail/ProEmailNewTitle';
import { EmailsContext } from '@/contexts/Emails/context';
import FaqEmails from '@/components/FrequentlyQuestions/FaqEmails';
import styles from './styles.module.css';
import { SUPPORT_URL } from '@/config/urls/supportUrls';

const ProEmailListWrapper = () => {
  const {
    firstLoad, loadingCpanel, loadingProEmails,
  } = useContext(EmailsContext);
  const [displaySearch, setDisplaySearch] = useState(true);

  const setEnableSearch = (isEnabled) => {
    setDisplaySearch(isEnabled);
  };

  if (firstLoad || loadingCpanel || loadingProEmails) {
    return <Loader data-testid="loader" />;
  }

  return (
    <>
      <ProEmailNewTitle displaySearch={displaySearch} />
      <ProEmailsNewList setEnableSearch={setEnableSearch} />
      <div className={styles.bottomInfoWrapper}>
        <FaqEmails link={SUPPORT_URL} />
      </div>
    </>
  );
};

export default ProEmailListWrapper;
